<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <PageHeader>
            <h1 class="ml-3 text-2xl font-bold text-gray-900 sm:truncate flex flex-row justify-between w-full">
                <span>
                    <span class="flex flex-row">
                        <Loader v-if="isStatusesFetchPending"
                                class="-sm m-2"/>
                        <template v-else>
                            Status
                        </template>
                    </span>
                    <LangSwitcher />
                </span>
                <span>
                    <a href="#" @click.prevent="handleCreateStatus"
                        class="flex items-center px-4 py-1 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-custom-600 hover:bg-custom-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                        Créer un status
                    </a>
                </span>
            </h1>
        </PageHeader>

        <div class="mt-8 lg:max-w-6xl lg:mx-auto">
            <div class="m-4">
                <Search
                    v-model="search"
                    @update:modelValue="handleSearchChange"
                />

                <List
                    :items="statuses"
                    :columns="columns"
                    :desc="desc"
                    @editItem="handleEditStatus"
                    @deleteItem="handleDeleteStatus"
                    @sortBy="handleSortBy"
                    editable
                    deletable
                />

                <Pagination
                    v-if="lastPage > 1"
                    :current_page="currentPage"
                    :last_page="lastPage"
                    @change="handleChangePage"
                />
            </div>
        </div>
    </main>
</template>

<script>
import PageHeader from "../../components/partials/page-header";
import Loader from "../../components/partials/loader";
import Pagination from "../../components/partials/pagination";
import Search from "../../components/partials/search";
import List from "../../components/partials/list";
import LangSwitcher from "../../components/partials/lang-switcher";

export default {
    beforeMount() {
        if (!this.project || this.project.id !== this.$route.params.project_id) {
            this.$store.dispatch('projects/getSingle', {id: this.$route.params.project_id, includes: ['buildings', 'categories', 'statuses']})
        }
    },
    data() {
        return {
            sort_by: null,
            desc: false,
            search: null,
            delayer: null,
        }
    },
    computed: {
        locale() {
            return this.$store.state.config.locale;
        },
        isStatusesFetchPending() {
            return this.$store.state.statuses.isFetchListPending;
        },
        project() {
            return this.$store.state.projects.single;
        },
        statuses() {
            return this.project && this.project.statuses ? this.project.statuses.data : [];
        },
        lastPage() {
            return this.$store.state.statuses.pagination.last_page
        },
        currentPage() {
            return this.$store.state.statuses.pagination.current_page
        },
        columns() {
            return {
                id: {
                    sortable: false,
                },
                ['translatable.name.' + this.locale]: {
                    sortable: true,
                    sortBy: 'name',
                    label: 'Nom'
                }
            }
        }
    },
    methods: {
        handleDeleteStatus(status) {
            this.$store.state.statuses.single = status;
            this.$store.dispatch('modals/open', 'status-delete');
        },
        handleChangePage(page = this.currentPage) {
            this.$store.dispatch('statuses/getList', {
                'page': page,
                'sort_by': this.sort_by,
                'desc': this.desc,
                'search': {'name': this.search}
            });
        },
        handleSortBy(type) {
            this.desc = !this.desc;
            this.sort_by = type;

            this.handleChangePage();
        },
        handleSearchChange(search) {
            this.search = search;
            this.handleChangePage();
        },
        handleCreateStatus() {
            this.$store.dispatch('statuses/resetSingle')
            this.$store.dispatch('modals/open', 'status-save');
        },
        handleEditStatus(status) {
            this.$store.dispatch('statuses/setSingle', status);
            this.$store.dispatch('modals/open', 'status-save');
        }
    },
    components: {
        PageHeader,
        Loader,
        Pagination,
        Search,
        List,
        LangSwitcher
    }
}
</script>
